import { motion, MotionConfig } from "framer-motion";
import { Badge } from "../../../components/ui/badge";
import { TestimonialsCarousel } from "../components/TestimonialsCarousel";
import { useInViewOnce } from "../../../hooks/useInViewOnce";

const TESTIMONIALS = [
  {
    name: "Dra. Helena Costa",
    role: "Diretora pedagógica — rede de ensino",
    content:
      "Pela primeira vez a família enxerga o mesmo recorte que a escola. Reduzimos cobrança desorganizada e aumentamos conversas produtivas sobre aprendizado.",
    rating: 5,
  },
  {
    name: "Ricardo Almeida",
    role: "Professor de Ciências",
    content:
      "Correção discursiva e devolutivas ficaram viáveis. O aluno sabe o que cai na prova e a IA ajuda a nivelar a turma sem eu duplicar esforço.",
    rating: 5,
  },
  {
    name: "Patrícia Nogueira",
    role: "Mãe de aluno do ensino médio",
    content:
      "Recebo alerta de prova e de tarefa atrasada no mesmo painel das notas. Parece simples, mas mudou o clima em casa.",
    rating: 5,
  },
];

export function TestimonialsSection() {
  const { ref, isVisible } = useInViewOnce();

  return (
    <MotionConfig reducedMotion="user">
      <section
        id="depoimentos"
        ref={ref}
        className="scroll-mt-20 border-b border-white/[0.06] bg-white/[0.02] py-16 sm:scroll-mt-24 sm:py-20 lg:py-24"
      >
        <div className="container mx-auto max-w-7xl px-4 sm:px-6">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, ease: [0, 0, 0.2, 1] }}
            className="mx-auto max-w-2xl text-center"
          >
            <Badge className="mb-4 border-amber-500/30 bg-amber-500/10 text-amber-200">
              Quem já sentiu a diferença
            </Badge>
            <h2 className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl md:text-4xl">
              Menos atrito.{" "}
              <span className="bg-gradient-to-r from-amber-300 to-teal-300 bg-clip-text text-transparent">
                Mais clareza.
              </span>
            </h2>
            <p className="mt-4 text-base leading-relaxed text-slate-400 sm:text-lg">
              Depoimentos ilustrativos do tipo de resultado que buscamos com escolas
              alinhadas ao NeuroMent.
            </p>
          </motion.div>

          <TestimonialsCarousel items={TESTIMONIALS} />
        </div>
      </section>
    </MotionConfig>
  );
}
